import React from 'react';
import { Control, Controller } from 'react-hook-form';
import InputMask from 'react-input-mask';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import TextField from 'common/components/TextField';
import { DEFAULT_GRID_CONTAINER_SPACING } from 'common/constants';
import {
    BILLING_ADDRESS,
    CITY,
    COMPANY,
    FIRST_NAME,
    LAST_NAME,
    PAYER_ADDRESS,
    PHONE_NUMBER,
    POST_CODE,
    SHIPPING_ADDRESS,
    STREET,
    STREET_NUMBER,
    DIFFERENT_DATA, RECIPIENT_SCHOOL_DATA
} from "../../../common/constants";
import { CheckoutValues } from 'store/ducks/checkout/types';
import { makeShipmentStyles } from 'styles/pages/checkout';
import ErrorPanel from 'common/components/ErrorPanel';
import { CART_TYPE } from 'common/types';

type Props = {
    checkoutValues: CheckoutValues;
    control: Control;
    errors: any;
    orderType?: string;
};

const ShipmentData: React.FC<Props> = ({ checkoutValues, control, errors, orderType }) => {
    const { copyButton, copyPanel } = makeShipmentStyles();
    const { getValues, setValue, triggerValidation } = control;
    const differentData = getValues()[DIFFERENT_DATA];
    const isOrderTypeSchool = orderType === CART_TYPE.SCHOOL;

    const copyData = (type: string) => () => {
        const values = getValues({ nest: true })[type];

        setValue(SHIPPING_ADDRESS, values);
        Object.keys(errors?.[SHIPPING_ADDRESS] || {}).length && triggerValidation();
    };

    const getName = (name: string) => `${SHIPPING_ADDRESS}.${name}`;

    const { city, company, firstName, lastName, phoneNumber, postcode, street, streetNumber } =
        checkoutValues.shippingAddress || {};

    return (
        <Grid container spacing={DEFAULT_GRID_CONTAINER_SPACING}>
            <Grid item xs={12}>
                <Box className={copyPanel}>
                    { (differentData && !isOrderTypeSchool) ? (
                        <Box className={copyButton} onClick={copyData(PAYER_ADDRESS)}>
                            Skopiuj dane płatnika / odbiorcy.
                        </Box>
                    ) : null}
                    { isOrderTypeSchool ? (
                        <Box className={copyButton} onClick={copyData(RECIPIENT_SCHOOL_DATA)}>
                            Skopiuj dane odbiorcy.
                        </Box>
                    ) : null}
                    <Box className={copyButton} onClick={copyData(BILLING_ADDRESS)}>
                        Skopiuj dane z faktury.
                    </Box>
                </Box>
            </Grid>
            <Grid item xs={12} md={5}>
                <Controller
                    as={<TextField fullWidth />}
                    control={control}
                    defaultValue={company || ''}
                    label="* Nazwa szkoły"
                    name={getName(COMPANY)}
                    variant="outlined"
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                <ErrorPanel errors={errors} name={getName(COMPANY)} />
            </Grid>
            <Grid item xs={12} md={4}>
                <Controller
                    as={<TextField fullWidth />}
                    control={control}
                    defaultValue={street || ''}
                    label="* Ulica"
                    name={getName(STREET)}
                    variant="outlined"
                />
                <ErrorPanel errors={errors} name={getName(STREET)} />
            </Grid>
            <Grid item xs={12} md={3}>
                <Controller
                    as={<TextField fullWidth />}
                    control={control}
                    defaultValue={streetNumber || ''}
                    label="* Nr domu / lokalu"
                    name={getName(STREET_NUMBER)}
                    variant="outlined"
                />
                <ErrorPanel errors={errors} name={getName(STREET_NUMBER)} />
            </Grid>
            <Grid item xs={12} md={3}>
                <Controller
                    as={
                        <InputMask alwaysShowMask={false} mask="99-999">
                            {(inputProps: any) => <TextField {...inputProps} fullWidth />}
                        </InputMask>
                    }
                    control={control}
                    defaultValue={postcode || ''}
                    label="* Kod pocztowy"
                    name={getName(POST_CODE)}
                    variant="outlined"
                />
                <ErrorPanel errors={errors} name={getName(POST_CODE)} />
            </Grid>
            <Grid item xs={12} md={4}>
                <Controller
                    as={<TextField fullWidth />}
                    control={control}
                    defaultValue={city || ''}
                    label="* Miejscowość"
                    name={getName(CITY)}
                    variant="outlined"
                />
                <ErrorPanel errors={errors} name={getName(CITY)} />
            </Grid>
            <Grid item xs={12} md={5}>
                <Controller
                    as={
                        <InputMask alwaysShowMask={false} mask="999999999">
                            {(inputProps: any) => <TextField fullWidth {...inputProps} />}
                        </InputMask>
                    }
                    control={control}
                    defaultValue={phoneNumber || ''}
                    label="* Telefon kom."
                    name={getName(PHONE_NUMBER)}
                    variant="outlined"
                />
                <ErrorPanel errors={errors} name={getName(PHONE_NUMBER)} />
            </Grid>
            <Grid item xs={12} md={5}>
                <Controller
                    as={<TextField fullWidth />}
                    control={control}
                    defaultValue={firstName || ''}
                    label="* Imię osoby do kontaktu"
                    name={getName(FIRST_NAME)}
                    variant="outlined"
                />
                <ErrorPanel errors={errors} name={getName(FIRST_NAME)} />
            </Grid>
            <Grid item xs={12} md={5}>
                <Controller
                    as={<TextField fullWidth />}
                    control={control}
                    defaultValue={lastName || ''}
                    label="* Nazwisko osoby do kontaktu"
                    name={getName(LAST_NAME)}
                    variant="outlined"
                />
                <ErrorPanel errors={errors} name={getName(LAST_NAME)} />
            </Grid>
        </Grid>
    );
};

export default ShipmentData;
